import { GlobalButtonStyle } from '@website-builder/model/style/global-button-style';

export class ButtonBase extends GlobalButtonStyle {
  size: string;
  color: string;
  textColor: string;
  borderWidth: string;
  borderColor: string;
  borderRadius: number;
  boxShadow: string;
  hoverBoxShadow: string;
  horizontalPadding: string;
  marginTop?: string;
  transition?: string;

  static normalize(styles: Partial<ButtonBase>): ButtonBase {
    const globalButtonStyle: GlobalButtonStyle = GlobalButtonStyle.normalize(styles);
    const pureStyles = new ButtonBase();

    Object.assign(pureStyles, globalButtonStyle);

    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.color = styles.color ?? pureStyles.color;
    pureStyles.textColor = styles.textColor ?? pureStyles.textColor;
    pureStyles.borderWidth = styles.borderWidth ?? pureStyles.borderWidth;
    pureStyles.borderColor = styles.borderColor ?? pureStyles.borderColor;
    pureStyles.borderRadius = styles.borderRadius ?? pureStyles.borderRadius;
    pureStyles.boxShadow = styles.boxShadow ?? pureStyles.boxShadow;
    pureStyles.hoverBoxShadow = styles.hoverBoxShadow ?? pureStyles.hoverBoxShadow;
    pureStyles.horizontalPadding = styles.horizontalPadding ?? pureStyles.horizontalPadding;
    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;
    pureStyles.transition = styles.transition ?? pureStyles.transition;

    return pureStyles;
  }
}
